module.exports = __webpack_public_path__ + "img/u2534.024631bf.png";